const Salary = () => {
    return (
        <div id="top" className="vision-card">

            <div className="table-section-wrap">
                <div className="schedule-header">
                    <h2>NAV JEEVAN INTERNATIONAL GORAKHPUR</h2>
                    <h3>Medical college road, Gorakhpur</h3>
                    <h5>Email- navjeevaninternational3@gmail.com</h5>
                    <br />
                    <h4>Teaching Staff : Details of Qualifications and Experience</h4>
                </div>
                <table className="table-section">
                    <thead>
                        <tr>
                            <th>SR.NO</th>
                            <th>Name</th>
                            <th>Post</th>
                            <th>QUALIFICATION</th>
                            <th>D.O.B</th>
                            <th>DATE OF APPOINT</th>
                            <th>DATE OF CONFIRM</th>
                            <th>TEACHING EXP</th>
                            <th>PAY SCALE</th>
                            <th>BASIC PAY</th>
                            <th>D.A 110%</th>
                            <th>E.P.F</th>
                            <th>TOTAL SALARY</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>1</td>
                            <td>------</td>
                            <td>Principal</td>
                            <td>M.A, B.Ed</td>
                            <td>07-04-1981</td>
                            <td>04-02-2015</td>
                            <td>04-04-2016</td>
                            <td>5 yrs</td>
                            <td>29500/66000</td>
                            <td>29500</td>
                            <td>32450</td>
                            <td>3540</td>
                            <td>58410</td>
                        </tr>

                        <tr>
                            <td>2</td>
                            <td>------</td>
                            <td>TGT</td>
                            <td>M.A, B.Ed</td>
                            <td>17-11-1977</td>
                            <td>07-02-2013</td>
                            <td>07-02-2014</td>
                            <td>9 yrs</td>
                            <td>9300/34800</td>
                            <td>13900</td>
                            <td>15290</td>
                            <td>1668</td>
                            <td>27522</td>
                        </tr>

                        <tr>
                            <td>3</td>
                            <td>------</td>
                            <td>TGT</td>
                            <td>B.A, B.Ed</td>
                            <td>13-05-1984</td>
                            <td>02-04-2013</td>
                            <td>02-04-2014</td>
                            <td>2 yrs</td>
                            <td>9300/34800</td>
                            <td>13900</td>
                            <td>15290</td>
                            <td>1668</td>
                            <td>27522</td>
                        </tr>

                        <tr>
                            <td>4</td>
                            <td>------</td>
                            <td>TGT</td>
                            <td>Msc, B.Ed</td>
                            <td>24-08-1979</td>
                            <td>03-04-2010</td>
                            <td>03-04-2011</td>
                            <td>5 yrs</td>
                            <td>9300/34800</td>
                            <td>13900</td>
                            <td>15290</td>
                            <td>1668</td>
                            <td>27522</td>
                        </tr>

                        <tr>
                            <td>5</td>
                            <td>------</td>
                            <td>TGT</td>
                            <td>B.A, B.Ed</td>
                            <td>13-03-1978</td>
                            <td>12-04-2010</td>
                            <td>12-04-2011</td>
                            <td>5 yrs</td>
                            <td>9300/34800</td>
                            <td>13900</td>
                            <td>15290</td>
                            <td>1668</td>
                            <td>27522</td>
                        </tr>

                        <tr>
                            <td>6</td>
                            <td>------</td>
                            <td>TGT</td>
                            <td>PhD</td>
                            <td>05-05-1982</td>
                            <td>02-04-2014</td>
                            <td>02-04-2015</td>
                            <td>1 yrs</td>
                            <td>9300/34800</td>
                            <td>13900</td>
                            <td>15290</td>
                            <td>1668</td>
                            <td>27522</td>
                        </tr>

                        <tr>
                            <td>7</td>
                            <td>------</td>
                            <td>TGT</td>
                            <td>M.C.A, B.Ed</td>
                            <td>01-01-1987</td>
                            <td>-</td>
                            <td>04-04-2016</td>
                            <td>1 yrs</td>
                            <td>9300/34800</td>
                            <td>9300</td>
                            <td>10230</td>
                            <td>0</td>
                            <td>19530</td>
                        </tr>

                        <tr>
                            <td>8</td>
                            <td>------</td>
                            <td>PTI</td>
                            <td>B.P.Ed</td>
                            <td>15-09-1987</td>
                            <td>04-04-2015</td>
                            <td>04-04-2016</td>
                            <td>1 yrs</td>
                            <td>9300/34800</td>
                            <td>9300</td>
                            <td>10230</td>
                            <td>1116</td>
                            <td>18414</td>
                        </tr>

                        <tr>
                            <td>9</td>
                            <td>------</td>
                            <td>PRT</td>
                            <td>Msc, B.Ed</td>
                            <td>01-08-1983</td>
                            <td>07-02-2013</td>
                            <td>07-02-2014</td>
                            <td>8 yrs</td>
                            <td>9300/34800</td>
                            <td>13900</td>
                            <td>15290</td>
                            <td>1560</td>
                            <td>27630</td>
                        </tr>

                        <tr>
                            <td>10</td>
                            <td>------</td>
                            <td>PRT</td>
                            <td>M.A, B.Ed</td>
                            <td>05-08-1987</td>
                            <td>03-04-2012</td>
                            <td>03-04-2013</td>
                            <td>3 yrs</td>
                            <td>9300/34800</td>
                            <td>13500</td>
                            <td>14850</td>
                            <td>1620</td>
                            <td>26730</td>
                        </tr>

                        <tr>
                            <td>11</td>
                            <td>------</td>
                            <td>PRT</td>
                            <td>B.A, B.Ed</td>
                            <td>11-11-1986</td>
                            <td>07-02-2013</td>
                            <td>07-02-2014</td>
                            <td>4 yrs</td>
                            <td>9300/34800</td>
                            <td>13500</td>
                            <td>14850</td>
                            <td>1620</td>
                            <td>26730</td>
                        </tr>

                        <tr>
                            <td>12</td>
                            <td>------</td>
                            <td>PRT</td>
                            <td>M.A, B.Ed</td>
                            <td>15-07-1976</td>
                            <td>04-02-2012</td>
                            <td>04-02-2013</td>
                            <td>11 yrs</td>
                            <td>9300/34800</td>
                            <td>9300</td>
                            <td>10230</td>
                            <td>1560</td>
                            <td>17970</td>
                        </tr>

                        <tr>
                            <td>13</td>
                            <td>------</td>
                            <td>PRT</td>
                            <td>M.A, B.Ed</td>
                            <td>10-02-1985</td>
                            <td>04-02-2013</td>
                            <td>04-02-2014</td>
                            <td>6 yrs</td>
                            <td>9300/34800</td>
                            <td>13500</td>
                            <td>14850</td>
                            <td>1620</td>
                            <td>16730</td>
                        </tr>

                        <tr>
                            <td>14</td>
                            <td>------</td>
                            <td>PRT</td>
                            <td>B.A, B.Ed</td>
                            <td>01-01-1985</td>
                            <td>-</td>
                            <td>04-04-2016</td>
                            <td>1 yrs</td>
                            <td>9300/34800</td>
                            <td>9300</td>
                            <td>10230</td>
                            <td>0</td>
                            <td>19530</td>
                        </tr>

                        <tr>
                            <td>15</td>
                            <td>------</td>
                            <td>PRT</td>
                            <td>M.A, B.Ed</td>
                            <td>14-11-1990</td>
                            <td>01-07-2014</td>
                            <td>01-07-2015</td>
                            <td>1 yrs</td>
                            <td>9300/34800</td>
                            <td>9300</td>
                            <td>10230</td>
                            <td>1116</td>
                            <td>18414</td>
                        </tr>

                        <tr>
                            <td>16</td>
                            <td>------</td>
                            <td>PRT</td>
                            <td>Mcom, B.Ed</td>
                            <td>01-08-1989</td>
                            <td>04-06-2013</td>
                            <td>04-06-2014</td>
                            <td>2 yrs</td>
                            <td>9300/34800</td>
                            <td>9300</td>
                            <td>10230</td>
                            <td>1080</td>
                            <td>18450</td>
                        </tr>

                        <tr>
                            <td>17</td>
                            <td>------</td>
                            <td>PRT</td>
                            <td>Msc, B.Ed</td>
                            <td>12-10-1982</td>
                            <td>03-04-2014</td>
                            <td>03-04-2015</td>
                            <td>1 yrs</td>
                            <td>9300/34800</td>
                            <td>9300</td>
                            <td>10230</td>
                            <td>1116</td>
                            <td>18414</td>
                        </tr>

                        <tr>
                            <td>18</td>
                            <td>------</td>
                            <td>Liberiary</td>
                            <td>M.Lib</td>
                            <td>02-01-1991</td>
                            <td>01-04-2015</td>
                            <td>01-04-2016</td>
                            <td>1 yrs</td>
                            <td>9300/34800</td>
                            <td>9300</td>
                            <td>10230</td>
                            <td>1116</td>
                            <td>18414</td>
                        </tr>

                        <tr>
                            <td>19</td>
                            <td>------</td>
                            <td>Music</td>
                            <td>M.A, Music</td>
                            <td>05-03-1989</td>
                            <td>04-04-2015</td>
                            <td>04-04-2016</td>
                            <td>1 yrs</td>
                            <td>9300/34800</td>
                            <td>9300</td>
                            <td>10230</td>
                            <td>1116</td>
                            <td>18414</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default Salary;